import styled from 'styled-components';

export const DocumentPreviewContainer = styled.div`
  border: 1px solid var(--gray-200);
  width: 22.5rem;
  height: 4.5rem;

  @media screen and (max-width: 500px) {
    width: 18rem;
  }
`;

DocumentPreviewContainer.displayName = 'DocumentPreviewContainer';

export const ImageDocumentPreview = styled.div`
  width: 4.5rem;
  height: 4.5rem;

  border-bottom-left-radius: var(--spacer-2);
  border-top-left-radius: var(--spacer-2);
`;

ImageDocumentPreview.displayName = 'ImageDocumentPreview';

export const TextFileName = styled.span`
  max-width: 12.313rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow-wrap: break-word;
`;

TextFileName.displayName = 'TextFileName';
